import { render, staticRenderFns } from "./SideMenu.vue?vue&type=template&id=2d2d325b&scoped=true&"
import script from "./SideMenu.js?vue&type=script&lang=js&"
export * from "./SideMenu.js?vue&type=script&lang=js&"
import style0 from "./SideMenu.scss?vue&type=style&index=0&id=2d2d325b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2d325b",
  null
  
)

export default component.exports